export default __webpack_public_path__ + "static/media/saopaulo.57a8e301.jpg";